import React from "react";
import Link from "next/link";
import {ImShare, ImUnlocked} from "react-icons/im";
import {useTekstClient} from "hooks/useTekstClient";
import ContentListItemRight from "./Components/ContentListItemRight";
import {useFormTitle} from "../../../../hooks/useFormTitle";
const ContentListItem = ({
                             weergaveCompact,
                             searchParams,
                             CustomToggle,
                             handleOpenInNieuwVenter,
                             handleBewerken,
                             item,
                             ingelogdeGebruiker,
                             handleBookmark
                         }) => {
    const {inhoud, kenmerk} = searchParams
    const {tekst, isLoadingTekst} = useTekstClient()

    const {formTitle} = useFormTitle()

    return <li key={item.id} className={`border-b border-inherit ${weergaveCompact ? 'my-0' : 'my-3'}`}>

        {/*Header*/}
        <div className={`flex`}>
            {/*Titel*/}
            <h2 className={`text-xl  ${weergaveCompact ? 'pb-0' : 'pb-2'} mr-2`}>
                {item.autorisatie !== 0 && <ImUnlocked className={`inline-block mt-[-3px] mr-2`}/>}
                <Link
                    href={`/mijn-mkg/support/kenniscentrum/id/${item.id}/${formTitle(item.content_gepubliceerd.titel)}`}
                    className={`#`}>{item.content_gepubliceerd.titel}</Link>
            </h2>

            {/*Menu Right*/}
            <div className={`ml-auto pt-1`}>
                <ContentListItemRight
                    item={item}
                    handleBookmark={handleBookmark}
                    handleOpenInNieuwVenter={handleOpenInNieuwVenter}
                    handleBewerken={handleBewerken}
                    CustomToggle={CustomToggle}
                />

            </div>
        </div>

        <div className={`flex items-start`}>
            {/*Typen & Categorie & Versie*/}
            <div className={`text-sm`}>

                {/*Typen*/}
                <div className={`flex items-center`}>
                    <div
                        className={`text-kleur-grijs-cyan mr-2 w-[60px]`}>{tekst('pagina:support:kenniscentrum:lijst-item:Type')}</div>
                    <Link
                        href={`/mijn-mkg/support/kenniscentrum?typen=${item.wiki_type.id}`}>{item.wiki_type.naam}</Link>
                </div>

                {/*Categorie*/}
                {item.categorieen.length > 0 && <div className={`flex items-start`}>
                    <div
                        className={`text-kleur-grijs-cyan mr-2 w-[60px]`}>{tekst('pagina:support:kenniscentrum:lijst-item:Categorie')}</div>
                    <div className={`flex flex-wrap`}>
                        {item.categorieen.length > 0 && item.categorieen?.map(categorie => {
                            return <Link key={item.id + categorie.id} className={`mr-2`}
                                         href={`/mijn-mkg/support/kenniscentrum?cat=${categorie.id}`}>
                                {categorie.path}
                            </Link>
                        })}
                    </div>
                </div>}


                {/*if Releasenotes*/}
                {inhoud && <div className={`flex items-center`}>
                    <div
                        className={`text-kleur-grijs-cyan mr-2 w-[60px]`}>{tekst('pagina:support:kenniscentrum:lijst-item:Versies')}</div>

                    {item.versies.length > 0 && item.versies.map((v, i) => {
                        const productLabel = item.producten.length > 0 && item.producten.find(x => x.id === v.pivot.product_id)
                        return <span key={item.id + v.nr + i}
                                     className={`text-white bg-kleur-grijs-cyan rounded-sm font-bold text-[10px] mr-1 px-1 h-[15px] leading-[15px]`}>{productLabel
                            ? `${productLabel.naam} | `
                            : `${item.producten.length > 0
                                ? item.producten.map(x => x.naam).join(' | ')
                                : ''} | `}{v.nr}
                                        </span>
                    })}
                </div>
                }

                {/*Kenmerk & releasenote*/}
                {inhoud && kenmerk && <div className={`flex items-center`}>
                    <div className={`text-kleur-grijs-cyan mr-2 w-[60px]`}>Kenmerk:</div>
                    <div
                        className={`text-white bg-kleur-grijs-cyan rounded-sm font-bold text-[10px] mr-1 px-1 h-[15px] leading-[15px]`}>{kenmerk}</div>

                </div>
                }
            </div>

            <div className={`ml-auto`}>
                {item.wiki_type.id !== 3 && <div className={`flex item-center`}>
                    {item.producten.length > 0 && item.producten.map(v => <div key={item.id + v.naam}
                                                                               className={`text-white bg-kleur-donker-blauw rounded-sm font-bold text-[10px] mr-1 px-1 h-[15px] leading-[15px]`}>{v.naam}</div>)}
                </div>
                }
            </div>

        </div>


        <p className={`overflow-hidden text-ellipsis line-clamp-3 mt-2 ${weergaveCompact ? 'mb-2' : 'mb-3'}`}>
            {!weergaveCompact && item.content_gepubliceerd.intro}
        </p>
    </li>
}
export default ContentListItem;